import axios from 'axios';
import apiConfig from '../../api.config';

export default async function getApiPaperlessCrendetials(hotel) {
  const {
    host,
    URIs: { getApiCredentials },
  } = apiConfig;

  const data = {
    hotel
  };

  const uri = `${host}${getApiCredentials}`;

  return await axios.post(uri, data).then(res => res.data);
}
